import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Message from 'components/Message';
import When from 'components/When';
import { bem } from 'helpers/class-name';

import { SELECTION_ROW_TYPE } from '../Modifiers.itemSelection';
import messages from './ModifierItemPicker.messages';

const { element } = bem('modifier-item-picker');

const ModifierSelectionRows = ({ rows, onRemove, disabled }) => {
  const intl = useIntl();

  return (
    <ul className={element('selection')}>
      {rows.map(row => (
        <li key={`${row.type}-${row.id}`} className={element('selection-row')}>
          <div className={element('selection-text')}>
            <span className={element('selection-name')}>{row.name}</span>
            <span className={element('selection-detail')}>
              {row.type === SELECTION_ROW_TYPE.MENU ? (
                <Message message={messages.usedInItems} values={{ count: row.itemCount }} />
              ) : (
                `${row.categoryName} · ${row.menuName}`
              )}
            </span>
          </div>
          <When predicate={!disabled}>
            <button
              type="button"
              className={element('selection-remove')}
              aria-label={intl.formatMessage(messages.removeItemAriaLabel, { name: row.name })}
              onClick={() => onRemove(row)}>
              <Message message={messages.removeSelection} />
            </button>
          </When>
        </li>
      ))}
    </ul>
  );
};

ModifierSelectionRows.propTypes = {
  disabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, type: PropTypes.string })).isRequired,
};

export default ModifierSelectionRows;
